import { useState } from "react";
import { useTheme } from "styled-components";
import { Formik } from "formik";
import { SearchForm, SearchInput, SearchIcon, Button } from "./styles";
import { schema, initialValues } from "../../../../../constants/form/search";
import MagnifierIcon from "../../../../../assets/icons/icon-cool/Magnifier.svg";
import { useLayout } from "../../../../../provider/LayoutProvider";

const Component = () => {
  const { setFilters } = useLayout();
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const [visible, setVisible] = useState<boolean>(false);
  const [formSubmmited, setFormSubmmited] = useState<boolean>(false);

  const onFormSubmit = ({ values, actions }) => {
    setFilters("query", values.query, "ADD");
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, actions) => {
        if (onFormSubmit) onFormSubmit({ values, actions });
      }}
      validateOnChange={formSubmmited}
      validateOnBlur={false}
      validationSchema={schema}
      enableReinitialize
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => {
        return (
          <SearchForm
            className={visible ? "open" : ""}
            onSubmit={(event) => {
              setFormSubmmited(true);
              handleSubmit(event);
            }}
            id="search-bar-form"
          >
            <SearchInput
              name="query"
              type="search"
              placeholder="Busca por título..."
              value={values["query"]}
              onChange={handleChange}
              onBlur={handleBlur}
              onKeyPress={(event) => {
                if (event.key === 'Enter' || event.charCode === 13) {
                  event.preventDefault();
                  handleSubmit();
                }
              }}
              // disabled={getCoursesStates.loading} Escuchar el state del getCourses
            />
            <Button
              type="button"
              onClick={() => {
                if (values["query"]) {
                  handleSubmit();
                } else {
                  setVisible((oldState) => !oldState);
                }
              }}
            >
              <SearchIcon
                icon={MagnifierIcon}
                size="16px"
                color={theme.colors.Black}
              />
            </Button>
          </SearchForm>
        );
      }}
    </Formik>
  );
};

export default Component;
